import './styles/tooltip.less'

export const createTooltipOverlay = (google, map) => {
	class TooltipOverlay extends google.maps.OverlayView {
		constructor(mapInstance) {
			super()
			this.setMap(mapInstance)
		}

		onAdd() {
			const container = document.createElement('div')
			container.className = 'google-maps-tooltip'

			const label = document.createElement('div')
			const arrow = document.createElement('div')
			arrow.className = 'google-maps-tooltip-arrow'

			container.appendChild(label)
			container.appendChild(arrow)

			this.container = container
			this.label = label
			this.arrow = arrow

			this.getPanes().floatPane.appendChild(container)
		}

		draw() {
			if (!this.container || !this.position) return
			const projection = this.getProjection()
			if (!projection) return
			const point = projection.fromLatLngToDivPixel(this.position)
			this.container.style.left = `${point.x}px`
			this.container.style.top = `${point.y}px`
		}

		onRemove() {
			if (this.container) this.container.remove()
			this.container = this.label = this.arrow = null
		}

		show(text, latLng) {
			this.position = latLng instanceof google.maps.LatLng ? latLng : new google.maps.LatLng(latLng)
			if (!this.container) return
			this.label.textContent = text
			this.container.classList.add('google-maps-tooltip-visible')
			this.draw()
		}

		hide() {
			this.container?.classList.remove('google-maps-tooltip-visible')
		}
	}

	return new TooltipOverlay(map)
}
